import react from 'react';
import AudioCubeApiCallerInstance from '../utils/AudioCubeApiCallerInstance';
import { SOUNDBOX_API_ENDPOINTS } from '../URLConstants';

export const GetAllVendor = async (pageNo, limit, where) => {
  const response = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS.VENDOR_URL, {
    params: {
      page: pageNo,
      limit,
      ...(where && { where: JSON.stringify(where) })
    }
  });
  return response;
};

export const GetVendorById = async (vendorId) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.VENDOR_URL}/${vendorId}`
  );
  return response;
};

export const CreateVendor = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.VENDOR_URL,
    payload
  );
  return response;
};

export const UpdateVendor = async (vendorId, payload) => {
  const response = await AudioCubeApiCallerInstance.patch(
    `${SOUNDBOX_API_ENDPOINTS.VENDOR_URL}/${vendorId}`,
    payload
  );
  return response;
};

export const GetVendorStats = async (startDate, endDate) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.VENDOR_URL}/alerts/summary?startDate=${startDate}&endDate=${endDate}`
  );
  return response;
};

export const DeleteVendor = async (vendorId) => {
  const response = await AudioCubeApiCallerInstance.delete(
    `${SOUNDBOX_API_ENDPOINTS.VENDOR_URL}/${vendorId}`
  );
  return response;
};

export const GetAllVendorLot = async (pageNo, limit, where) => {
  const response = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS.VENDOR_LOT_URL, {
    params: {
      page: pageNo,
      limit,
      ...(where && { where: JSON.stringify(where) })
    }
  });
  return response;
};

export const CreateVendorLot = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.VENDOR_LOT_URL,
    payload
  );
  return response;
};

export const UpdateVendorLot = async (vendorLotId, payload) => {
  const response = await AudioCubeApiCallerInstance.patch(
    `${SOUNDBOX_API_ENDPOINTS.VENDOR_LOT_URL}/${vendorLotId}`,
    payload
  );
  return response;
};

export const DeleteVendorLot = async (vendorLotId) => {
  const response = await AudioCubeApiCallerInstance.delete(
    `${SOUNDBOX_API_ENDPOINTS.VENDOR_LOT_URL}/${vendorLotId}`
  );
  return response;
};
